var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIphone = function SvgIphone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 32,
    width: 6,
    height: 48,
    fill: "#FC628F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 0H15C13.3439 0.00176371 12.0018 1.34388 12 3V47C12.0018 48.6561 13.3439 49.9982 15 50H37C38.6561 49.9982 39.9982 48.6561 40 47V3C39.9982 1.34388 38.6561 0.00176371 37 0ZM38 47C38 47.5523 37.5523 48 37 48H15C14.4477 48 14 47.5523 14 47V40H38V47ZM14 38H38V3C38 2.44772 37.5523 2 37 2H15C14.4477 2 14 2.44772 14 3V38Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 46C27.1046 46 28 45.1046 28 44C28 42.8954 27.1046 42 26 42C24.8954 42 24 42.8954 24 44C24 45.1046 24.8954 46 26 46Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6H23C22.4477 6 22 6.44772 22 7C22 7.55228 22.4477 8 23 8H29C29.5523 8 30 7.55228 30 7C30 6.44772 29.5523 6 29 6Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iphone.bf40a96250e70599133f093a35807afa.svg";